import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const userSchema = surrealRecordSchema.extend({
  email: z.string(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
});

export type User = z.infer<typeof userSchema>;
